module.exports = "../img/wezimed-1q8bWAc.svg";